import { useEffect, useState } from "react";
import { HubSheet } from "../AdminPortal/HubPwa";
import aa from "../AdminPortal/adminApp.module.css";
import { ABSENCE_REASON_PRESETS } from "./calendarUtils";

export default function AttendanceAbsenceSheet({
  open,
  onClose,
  subtitle,
  onPick,
}) {
  const [customOpen, setCustomOpen] = useState(false);
  const [customText, setCustomText] = useState("");

  useEffect(() => {
    if (!open) {
      setCustomOpen(false);
      setCustomText("");
    }
  }, [open]);

  const handleClose = () => {
    setCustomOpen(false);
    setCustomText("");
    onClose?.();
  };

  const pick = (reasonId) => {
    onPick?.(reasonId);
    handleClose();
  };

  const submitCustom = () => {
    const text = customText.trim();
    if (text.length < 2) return;
    onPick?.(text.slice(0, 200));
    handleClose();
  };

  return (
    <HubSheet
      open={open}
      onClose={handleClose}
      title="Причина отсутствия"
      subtitle={subtitle}
      bodyClassName={aa.journalAbsenceSheetBody}
    >
      <p className={aa.journalAbsenceLead}>
        Отметка «Не был» попадёт в перекличку. Можно выбрать готовый вариант или
        написать своё.
      </p>
      <div className={aa.journalAbsenceGrid}>
        {ABSENCE_REASON_PRESETS.map((opt) => (
          <button
            key={opt.id}
            type="button"
            className={aa.journalAbsenceOption}
            onClick={() => pick(opt.id)}
          >
            <span className={aa.journalAbsenceOptionIcon} aria-hidden>
              {opt.icon}
            </span>
            <span className={aa.journalAbsenceOptionText}>
              <span className={aa.journalAbsenceOptionLabel}>{opt.label}</span>
              <span className={aa.journalAbsenceOptionHint}>{opt.hint}</span>
            </span>
          </button>
        ))}
      </div>
      {!customOpen ? (
        <button
          type="button"
          className={aa.journalAbsenceCustomToggle}
          onClick={() => setCustomOpen(true)}
        >
          Своя причина
        </button>
      ) : (
        <div className={aa.journalAbsenceCustom}>
          <label className={aa.journalAbsenceCustomLabel} htmlFor="absence-custom">
            Комментарий
          </label>
          <textarea
            id="absence-custom"
            className={aa.journalAbsenceCustomInput}
            rows={3}
            maxLength={200}
            placeholder="Например: семейные обстоятельства, выезд на турнир…"
            value={customText}
            onChange={(e) => setCustomText(e.target.value)}
            autoFocus
          />
          <div className={aa.journalAbsenceCustomActions}>
            <button
              type="button"
              className={aa.journalAbsenceCustomGhost}
              onClick={() => {
                setCustomOpen(false);
                setCustomText("");
              }}
            >
              Отмена
            </button>
            <button
              type="button"
              className={aa.journalAbsenceCustomSave}
              disabled={customText.trim().length < 2}
              onClick={submitCustom}
            >
              Сохранить
            </button>
          </div>
        </div>
      )}
    </HubSheet>
  );
}
